<template>
  <div class="post">
    <h3 class="h3 title">{{ title }}</h3>
    <div class="lead" v-html="lead"/>
    <a :href="link" class="more" v-if="has_content">mehr Details<i class="icon-more"></i></a>
  </div>
</template>

<script>
export default {
  name: 'post',
  props: {
    'filters': Array,
    'link': String,
    'title': String,
    'lead': String,
    'has_content': Boolean
  }
}
</script>
